import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../store/hooks";
import { selectNextPossibleDateConfigs } from "../formComponentSlicer";
import { format } from "date-fns";

export interface NextPossibleDateInputProps {
  title: string;
  stitchTypeId: string;
  onChange: (value: string, id: string) => void;
  configId: string;
  description?: string;
}

export const NextPossibleDateInput: React.FC<NextPossibleDateInputProps> = ({
  title,
  stitchTypeId,
  onChange,
  configId,
  description,
}) => {
  const configs = useAppSelector(selectNextPossibleDateConfigs);
  const [nextDate, setNextDate] = useState<Date | null>(null);
  //Style Helpers
  const getDefaultMargin = () => {
    return { margin: "15px 0" };
  };

  const getColor = () => {
    return "white";
  };

  const getBorderColor = () => {
    return "white";
  };

  // Styles mapped from Tailwind to inline React styles
  const styles: { [key: string]: React.CSSProperties } = {
    container: { width: "100%", display: "flex", flexDirection: "column" },
    rowBetween: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: "100%",
    },
    relativeFullCol: {
      position: "relative",
      width: "100%",
      display: "flex",
      flexDirection: "column",
    },
    inputBase: {
      backgroundColor: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderRadius: 8,
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      paddingTop: 8,
      paddingBottom: 8,
    },
    inputSmall: { minWidth: "190px", height: 38, cursor: "pointer" },
    absoluteRightTop: {
      position: "absolute",
      right: 12,
      top: 8,
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    smallBorderDiv: {
      borderWidth: 1,
      borderStyle: "solid",
      height: 20,
      marginRight: 12,
    },
    selectList: {
      position: "absolute",
      marginTop: 40,
      minWidth: "190px",
      borderWidth: 1,
      borderStyle: "solid",
      borderRadius: 12,
      boxShadow: "0 10px 15px rgba(0,0,0,0.08)",
      textAlign: "start",
      maxHeight: 200,
      overflow: "auto",
      backgroundColor: "#ffffff",
    },
    optionItem: {
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 8,
      paddingBottom: 8,
      cursor: "pointer",
      listStyleType: "none",
    },
    flexColStartMt4: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      alignItems: "flex-start",
      marginTop: "4px",
    },
    headerTitle: {
      fontSize: 15,
      lineHeight: "23px",
      fontWeight: "bold",
      alignSelf: "flex-start",
      textAlign: "left",
      marginTop: "4px",
      marginBottom: "4px",
    },
    headerSmallCentered: {
      fontSize: 13,
      lineHeight: "23px",
      fontWeight: "bold",
      alignSelf: "center",
      textAlign: "left",
      marginTop: "4px",
      marginBottom: "0px",
    },
  };

  const handleSelectOptionClick = () => {
    // Calculate the next possible date based on the selected day
    const config = configs[configId];
    console.log("Using configId: " + configId);
    console.log(configs);
    console.log(config);
    if (config) {
      const today = new Date();
      let nextPossibleDate: Date | null = null;
    let option = today.getDate();
      for (const range of config.ranges) {
        if (option >= range.startDay && option <= range.endDay) {
          const month = today.getMonth() + range.monthInterval;
          const year = today.getFullYear() + Math.floor(month / 12);
          const adjustedMonth = month % 12;
          const currentMonthDays = new Date(year, adjustedMonth + 1, 0).getDate();
          const adjustedMonthDay = Math.min(range.monthDay, currentMonthDays);
          nextPossibleDate = new Date(year, adjustedMonth, adjustedMonthDay);
          setNextDate(nextPossibleDate);
          onChange(formatDate(nextPossibleDate), stitchTypeId + ".nextDate");
          onChange(adjustedMonthDay.toString(), stitchTypeId + ".selectedDay");
          onChange(formatDate(nextPossibleDate), stitchTypeId);
          onChange(formatDate(today), stitchTypeId + ".currentDate");
          break;
        }
      }
    }
  };

  const formatDate = (date: Date): string => {
    const dateFormat = "dd/MM/yyyy";
    return format(date, dateFormat);
  };

  useEffect(() => {
    // On mount, calculate the next possible date based on today's date
    handleSelectOptionClick();
  }, []);

  return (
    <div style={{ ...styles.container, ...getDefaultMargin() }}>
      <div style={styles.rowBetween}>
        <h6 style={{ ...styles.headerTitle, color: getColor() }}>
          {title || "Este es el día de descuento segun la fecha actual"}
        </h6>
      </div>
      <div>
        <div style={{ ...styles.rowBetween, width: "100%" }}>
          <div style={styles.relativeFullCol}>
            <input
              style={{
                ...styles.inputBase,
                color: getColor(),
                borderColor: getBorderColor(),
              }}
              type="text"
              inputMode="numeric"
              disabled={true}
              value={nextDate ? nextDate.getDate() : ""}
            />
          </div>
        </div>
      </div>
      {/* Plazo */}
      <div style={styles.flexColStartMt4}>
        <h6
          style={{
            ...styles.headerTitle,
            color: getColor(),
            marginTop: "14px",
          }}
        >
          {description || "Siguiente fecha"}
        </h6>
        <input
          style={{
            ...styles.inputBase,
            color: getColor(),
            borderColor: getBorderColor(),
          }}
          type="text"
          inputMode="numeric"
          disabled={true}
          value={nextDate ? formatDate(nextDate) : ""}
        />
      </div>
    </div>
  );
};
